import { GetDefaultCurrencyResponseBody } from '../types/generated/defaultCurrency_get.response';
import apiEndpoints from '../../apiEndpoints';
import { fetcher } from '../utils/fetchers/fetcher';

export const requestDefaultCurrency = (
  token: string | null,
  forceHeader?: string
): Promise<GetDefaultCurrencyResponseBody> =>
  fetcher<GetDefaultCurrencyResponseBody>(
    apiEndpoints.routes.defaultCurrency,
    'GET',
    token,
    forceHeader
  );
